// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fc-a";
export var fulfillmentFormRail = "_fc-9";
export var headerTitleRow = "_fc-c";
export var orderDetailsWrapper = "_fc-7";
export var orderLinkTrigger = "_fc-2";
export var paymentInformationGrid = "_fc-h";
export var paymentSummaryColumn = "_fc-i";
export var shipmentContainer = "_fc-b";
export var shipmentDetailsMainPane = "_fc-8";
export var shipmentNavigationCard = "_fc-5";
export var shipmentNavigationRail = "_fc-3";
export var shipmentNavigationRailHeader = "_fc-4";
export var shipmentSummaryFact = "_fc-e";
export var shipmentSummaryGrid = "_fc-d";
export var shipmentSummaryMetadataRow = "_fc-f";
export var shipmentSummaryTags = "_fc-g";
export var shipmentWorkspace = "_fc-0";
export var shipmentWorkspaceContent = "_fc-6";
export var shipmentWorkspaceHeader = "_fc-1";